import type { ReportConversionFunction } from '../types';

/**
 * Fires conversion pixel for PerformCB referrals.
 */
export const reportPerformCBConversion: ReportConversionFunction = (event, partnerData): void => {
  // Get clickID passed in by PerformCB in the referral URL
  const { data } = partnerData;

  if (data.cbtid) {
    const ifrmPixel = window.document.createElement('iframe');
    ifrmPixel.setAttribute('src', `https://track.clickbooth.com/l/con?cbiframe=1&ogid=812&cbtid=${data.cbtid}`);
    ifrmPixel.setAttribute('loading', 'eager');
    ifrmPixel.style.width = '1';
    ifrmPixel.style.height = '1';
    ifrmPixel.scrolling = 'no';
    ifrmPixel.frameBorder = '0';
    window.document.body.appendChild(ifrmPixel);
  }

  // Append iframe pixel to fire conversion event
  if (data.clickID && data.cbtid) {
    const ifrm = window.document.createElement('iframe');
    ifrm.setAttribute('src', `https://track.clickbooth.com/l/con?ogid=812&clickid=${data.clickID}&cbtid=${data.cbtid}`);
    ifrm.style.width = '1';
    ifrm.style.height = '1';
    ifrm.frameBorder = '0';
    window.document.body.appendChild(ifrm);
  }
};
